import React from 'react';

import { EmailTemplateHtmlPreviewType } from '@dashboard/generated/wp/platform';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { NorthEastOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import SampleTemplateCard from '../../../../WaypointTemplatesList/CreateTemplateButton/ChooseTemplateDialog/SampleTemplateCard';

type Props = {
  active: boolean;
  templateId: string;
  templateName: string;
  onClick: () => void;
};
export default function LayoutSelectorTemplateCard({ active, templateId, templateName, onClick }: Props) {
  const platformId = useCurrentPlatformId();
  return (
    <SampleTemplateCard
      active={active}
      templateId={templateId}
      templateType={EmailTemplateHtmlPreviewType.Template}
      onClick={onClick}
      title={templateName}
      actions={
        <Tooltip title="Edit layout">
          <IconButton
            type="button"
            size="small"
            href={`/o/${platformId}/templates/${templateId}`}
            target="_blank"
            onClick={(ev) => {
              ev.stopPropagation();
            }}
          >
            <NorthEastOutlined sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      }
    />
  );
}
